/** Angular */
import {ChangeDetectorRef, Injectable} from '@angular/core';

import {AbstractControl, FormGroup} from '@angular/forms';

import numeral from 'numeral';
import moment from 'moment';
import {isObject} from 'rxjs/internal-compatibility';
import {isBoolean} from 'lodash-es';

import _ from 'lodash';
import {NotificationUtilsService} from './notification-utils.service';
import {NgxImageCompressService} from 'ngx-image-compress';

@Injectable()
export class FormUtilsService {

    constructor(private _notificationUtilsService: NotificationUtilsService,
                private imageCompress: NgxImageCompressService) {
    }

    getErrorMessage(form: any, controlName: string, minLength: number = 3, maxlength: number = 320, minValue: number = 1, maxValue: number = 3): any {
        const control = form.controls[controlName];
        if (control.hasError('minlength')) {
            return 'Minimum field length: ' + minLength;
        }
        if (control.hasError('pattern')) {
            return 'You entered an incorrect link';
        }
        if (control.hasError('maxlength')) {
            return 'Maximum field length: ' + maxlength;
        }
        if (control.hasError('matDatetimePickerMin')) {
            return 'Stop at must be after Start at';
        }
        if (control.hasError('min')) {
            return 'Minimum value ' + control.errors.min.min;
        }
        if (control.hasError('max')) {
            return 'Maximum value ' + control.errors.max.max;
        }
        if (control.hasError('email')) {
            return 'Not a valid email';
        }
        if (control.hasError('validatePhoneNumber')) {
            return 'Not a valid phone number';
        }
        if (control.hasError('ccNumber') || control.hasError('expDate') || control.hasError('cvv')) {
            return 'Field is not valid';
        }
        if (control.hasError('mustMatch')) {
            return 'New password and confirm new password do not match';
        }
        if (control.hasError('serverError')) {
            return control.getError('serverError');
        }
        return control.hasError('required') ? 'You must enter a value' : '';
    }

    prepareServerError(response: any = null, form: FormGroup = null, cdr: ChangeDetectorRef = null): any {
        if (!response || !response.error) {
            return console.log('!response.error');
        }
        let errors = response.error.errors;
        if (!errors && response.error.error && typeof response.error.error !== 'string') {
            errors = response.error.error;
        }
        if (errors) {
            Object.keys(errors).map(field => {
                let error = '';
                if (errors[field] && errors[field].length) {
                    errors[field].map(text => {
                        error += text;
                    });
                }
                if (form && form.controls[field]) {
                    form.controls[field].setErrors({'serverError': error});
                }
            });
            // Mark for check
            if (cdr) {
                cdr.markForCheck();
            }
            const message = response.error.message ? response.error.message : 'The given data was invalid.';
            return this.getMessage(message);
        } else {
            // Show the error message
            let message = 'The given data was invalid.';
            if (response.error.error && typeof response.error.error === 'string') {
                message = response.error.error;
            } else if (response.error && response.error === 'string') {
                message = response.error;
            }
            return this.getMessage(message);
        }
    }

    getMessage(message: string, type: string = 'error'): any {
        return {
            appearance: 'outline',
            content: message,
            shake: true,
            showIcon: false,
            type: type
        };
    }

    selectFilter(selectArray: any, value: string): string[] {
        const filterValue = this.normalizeValue(value);
        return selectArray.filter(item => {
            const itemValue = item.name ? item.name : item.label ? item.label : item;
            return this.normalizeValue(itemValue).includes(filterValue);
        });
    }

    normalizeValue(value: string): string {
        return value.toLowerCase().replace(/\s/g, '');
    }

    checkRequired(form, field): boolean {
        if (form && form.get(field) && form.get(field).validator) {
            return form.get(field).validator({} as AbstractControl) && form.get(field).validator({} as AbstractControl).required;
        }
        return false;
    }

    cleanIncludeExclude(value: string, isValidEmail: boolean = false): string {
        const emailReg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        value = this.delBlankLines(value);
        value = value.replace(/[,]{2,}/g, ',').replace(/%/g, '')
            .replace(/\r\n|\n|\r/g, ',').replace(/(^[ \t]*\n)/gm, '');
        let tempArr = value.split(',');
        if (tempArr && tempArr.length) {
            tempArr = tempArr.map(val => {
                return val.trim().replace(/\s{2,}/g, ' ').replace(/\.$/, '');
            });
            if (isValidEmail) {
                tempArr = tempArr.filter(val => {
                    return emailReg.test(val);
                });
            }
            // удаление пустых елементов
            tempArr = tempArr.filter(val => val);
            // удаление одинаковых елементов
            tempArr = [...new Set(tempArr)];
            return tempArr.join(',');
        }
        return '';
    }

    delBlankLines(text): string {
        const stringArray = text.split('\n');
        const temp = [''];
        let x = 0;
        stringArray.map(val => {
            if (!!val) {
                temp[x] = val;
                x++;
            }
        });

        return temp.join('\n');
    }

    isNumeric(n): boolean {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }

    validationEmail(val: string): boolean {
        const emailReg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        return emailReg.test(val);
    }

    formatMoney(val: string | number): string {
        return numeral(val).format('0,0.00');
    }

    formatDate(date: string, format: string): string | null {
        if (date) {
            return date = moment(date).format(format);
        }
        return null;
    }

    mustMatch(controlName: string, matchingControlName: string): any {
        return (formGroup: FormGroup) => {
            const control = formGroup.controls[controlName];
            const matchingControl = formGroup.controls[matchingControlName];
            if (matchingControl.errors && !matchingControl.errors.mustMatch) {
                // return if another validator has already found an error on the matchingControl
                return;
            }
            // set error on matchingControl if validation fails
            if (control.value !== matchingControl.value) {
                matchingControl.setErrors({mustMatch: true});
            } else {
                matchingControl.setErrors(null);
            }
        };
    }

    toggleActive(val, form, fields, cdr: any, isClearField = false): void {
        // const required = val && isBoolean(val) || val.checked ? Validators.required : null;
        fields.map(field => {
            if (form.controls[field]) {
                if (isClearField) {
                    form.controls[field].setValue('');
                }
                form.controls[field].markAsUntouched();
                form.controls[field].updateValueAndValidity();
            }
        });
        form.updateValueAndValidity();
        cdr.markForCheck();
    }

    validation(form: any, collapse = false, collapseName = '', arrCollapse?: any[]): void {
        const controls = form.controls;
        Object.keys(controls).forEach(controlName => {
            if (controls[controlName].controls) {
                if (collapse && controls[controlName].invalid && arrCollapse) {
                    arrCollapse.push(controlName);
                }
                this.validation(controls[controlName], controlName === collapseName, controlName, arrCollapse);
            }
            controls[controlName].markAsTouched();
        });
    }

    checkEmptyField(data: any): void {
        Object.keys(data).forEach(fieldName => {
            if (isObject(data[fieldName])) {
                this.checkEmptyField(data[fieldName]);
            } else if (!data[fieldName] && data[fieldName] !== 0 && data[fieldName] !== false) {
                delete data[fieldName];
            } else if (isBoolean(data[fieldName])) {
                data[fieldName] = data[fieldName] ? 1 : 0;
            }
        });
        return data;
    }

    capitalize(s): string {
        return s[0].toUpperCase() + s.slice(1);
    }

    formatBytes(bytes, decimals = 0): any {
        if (bytes === 0) {
            return '0 Bytes';
        }
        const k = 1024;
        const dm = decimals <= 0 ? 0 : decimals || 2;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
    }

    dataURItoBlob(dataURI): Blob {
        const byteString = atob(dataURI.replace(/^[^,]+,/, ''));
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        return new Blob([int8Array], {type: 'image/jpeg'});
    }


    setValuesInForm(form, value): void {
        const controls = form.controls;
        Object.keys(controls).forEach(controlName => {
            if (controls[controlName].controls && value[controlName]) {
                return this.setValuesInForm(controls[controlName], value[controlName]);
            }
            if (_.has(value, controlName)) {
                controls[controlName].setValue(_.get(value, controlName, ''));
            }
        });
    }

    gelObjectValue(object: any, path: string): any {
        if (_.has(object, path)) {
            return _.get(object, path, '');
        }
        return null;
    }

    compressFiles(file, fileUrl, control, index = null): void {
        const maxSize = 4194304;
        const minSize = 50000;
        const images = control.value || [];
        this.imageCompress.compressFile(fileUrl, -1).then(
            result => {
                let blob = this.dataURItoBlob(result);
                let imageFile = new File([blob], file.name, {type: file.type});
                if (imageFile?.size && imageFile.size > maxSize) {
                    const message = `${file.name} Exceeds the max upload size. Max upload size is 4MB`;
                    this._notificationUtilsService.showActionNotification(message, 0);
                    return;
                }
                imageFile['imageUrl'] = result;
                if (imageFile?.size && imageFile.size < minSize) {
                    blob = this.dataURItoBlob(fileUrl);
                    imageFile = new File([blob], file.name, {type: file.type});
                    imageFile['imageUrl'] = fileUrl;
                }
                imageFile['isNew'] = true;
                if (index || index === 0) {
                    images.splice(index, 1, imageFile);
                } else {
                    images.push(imageFile);
                }
                control.setValue(images);
            });
    }

    prepareSelectorArray(obj: any, array: any[], field = null): void {
        Object.keys(obj).map(key => {
            const item = {
                name: obj[key] + ' ' + key,
                code: key
            };
            if (field) {
                item[field] = key;
            }
            array.push(item);
        });
    }

}
